import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.92995 19.07C4.7437 18.8826 4.63916 18.6292 4.63916 18.365C4.63916 18.1008 4.7437 17.8474 4.92995 17.66L17.66 4.92999C17.7496 4.82531 17.8599 4.74029 17.984 4.68026C18.108 4.62024 18.2432 4.58651 18.3809 4.58119C18.5186 4.57587 18.6559 4.59908 18.7843 4.64935C18.9126 4.69963 19.0291 4.77588 19.1266 4.87334C19.2241 4.97079 19.3003 5.08734 19.3506 5.21567C19.4009 5.34399 19.4241 5.48132 19.4188 5.61904C19.4134 5.75676 19.3797 5.89189 19.3197 6.01596C19.2597 6.14002 19.1746 6.25034 19.07 6.33999L6.33995 19.07C6.15259 19.2562 5.89914 19.3608 5.63495 19.3608C5.37077 19.3608 5.11732 19.2562 4.92995 19.07Z"
        fill="#0E1317"
      />
      <path
        d="M4.92995 4.92998C5.11732 4.74373 5.37077 4.63919 5.63495 4.63919C5.89914 4.63919 6.15259 4.74373 6.33995 4.92998L19.07 17.66C19.1746 17.7496 19.2597 17.8599 19.3197 17.984C19.3797 18.1081 19.4134 18.2432 19.4188 18.3809C19.4241 18.5186 19.4009 18.656 19.3506 18.7843C19.3003 18.9126 19.2241 19.0292 19.1266 19.1266C19.0291 19.2241 18.9126 19.3003 18.7843 19.3506C18.6559 19.4009 18.5186 19.4241 18.3809 19.4188C18.2432 19.4135 18.108 19.3797 17.984 19.3197C17.8599 19.2597 17.7496 19.1747 17.66 19.07L4.92995 6.33998C4.7437 6.15262 4.63916 5.89917 4.63916 5.63498C4.63916 5.3708 4.7437 5.11735 4.92995 4.92998Z"
        fill="#0E1317"
      />
    </Svg>
  );
};

export default Icon;
